import api from '@/api/api.js'

export default {
    getExamens() {
        const promise = api.clinique().get("/type_examens");
        return promise.then((response) => response.data);
    },
    storeBonExamen(idPatient, data) {
        const promise = api
            .clinique()
            .post(`/patient_externe/${idPatient}/select-examens`, data);
        return promise.then((response) => response.data);
    },
    getAllExamensForExterne() {
        const promise = api.clinique().get(`examens-des-patients-externes/all`);
        return promise.then((response) => response.data);
    },

    getConsultationExamen(data) {
        const promise = api.clinique().get("/examens/consultation/"+data.consultation_id+'/'+data.etat_paiement);
        return promise.then((response) => response.data);
    },

    updateBulExamen(data) {
        const promise = api.clinique().put("/examens/consultation/save_paiement", data);
        return promise.then((response) => response.data);
    },

    updateBulExamenDiffere(data) {
        const promise = api.clinique().put("/examens/consultation/update_paiement", data);
        return promise.then((response) => response.data);
    },

    getExamenFactureEnCours() {
        const promise = api.clinique().get("/examens/facture_en_cours");
        return promise.then((response) => response.data);
    },

    getPrixAssurExamen(data) {
        const promise = api.clinique().post("/bon/examens", data);
        return promise.then((response) => response.data);
    },

    getRefBonExamen() {
        const promise = api.clinique().get("/bon/reference/examen");
        return promise.then((response) => response.data);
    },

    savePendingExamen(data) {
        const promise = api.clinique().post('/bon/examen/paiement', data)
        return promise.then((response) => response.data)
    },

    getBulletinExamen(data) {
        const promise = api.clinique().post('/bulletin-examens/liste', data)
        return promise.then((response) => response.data)
    },
};